import { useEffect, useState } from 'react'

/** The value, once it has stopped changing for `ms`.
 *
 *  For a search box that asks the server: one request when the typing
 *  pauses, not one per keystroke. */
export function useDebounced<T>(value: T, ms = 300): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const t = window.setTimeout(() => setSettled(value), ms)
    return () => window.clearTimeout(t)
  }, [value, ms])
  return settled
}
